import { useState, createContext, useContext, useEffect } from "react";
import { ChainResponse } from "baaanggg";
import { useChains } from "@hooks/ChainsHook";
import { useLCDClient } from "@terra-money/wallet-provider";

const SelectedChainContext = createContext<{
  selectedChain?: ChainResponse,
}>({});

export const useSelectedChain = () => useContext(SelectedChainContext);

export const ChainSelector = ({ children }: { children: React.ReactNode; }) => {
  const chains = useChains()
  const [chain, setChain] = useState<ChainResponse>();
  const lcd = useLCDClient();

  useEffect(() => {
    const chain = chains.find(e => e.chainId == lcd.config.chainID);
    if (chain) setChain(chain)
    else setChain(chains.find(e => e.chainId == "columbus-5"))
  }, [lcd, chains]);

  return (
    <SelectedChainContext.Provider value={{
      selectedChain: chain
    }}>
      <>{children}</>
    </SelectedChainContext.Provider>
  );
};
